import { FC } from 'react';
import c from 'classnames';
import { Typography } from '../Typography/Typography';
import styles from './StatusPill.module.css';
import type { StatusColor } from '@repo/types';

export interface StatusPillProps {
  status: string;
  color: StatusColor;
  onClick?: () => void;
}

export const StatusPill: FC<StatusPillProps> = ({ status, color, onClick }) => {
  return (
    <div
      className={c(
        styles.statusPill,
        styles[color],
        onClick && styles.clickable,
      )}
      onClick={onClick}
    >
      <div className={c(styles.dot, styles[color])} />
      <Typography variant='label'>{status}</Typography>
    </div>
  );
};
